// extracted by mini-css-extract-plugin
module.exports = {"modelStyles":"modelStyles___Kv3cz","successIcon":"successIcon___9qksw","mainDiv":"mainDiv___RSqIX","header":"header___3aBim","description":"description___EGh8l"};